<template>
  <div class="join-challenge-popup">
    <colored-popup
      class="primary"
      :darkText="false"
      :close-action="close">

      <template v-slot:top-content>
        <div class="title">שמחים שהחלטת להצטרף!</div>
      </template>

      <template v-slot:bottom-content>
        <div class="description">איך החברים קוראים לך?</div>
        <text-input class="nickname-input" :autofocus="true" :labelText="'כינוי'" :value="nickname" :onInput="setNickname"/>
        <riseup-button title="הצטרפו לאתגר" variant="primary" size="slim" :action="joinChallengeClicked" :disabled="buttonDisabled"/>
      </template>
    </colored-popup>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import BaseUI from 'base-ui';
import Segment from '@/Segment';
import {
  EATING_OUT_CHALLENGE_PROTOTYPE_V1,
} from '@/pages/responsive-pages/authenticated/multiplayer-experience/accountability-group-challenge/constants';

export default {
  name: 'JoinChallengePopup',
  components: {
    ColoredPopup: BaseUI.ColoredPopup,
    RiseupButton: BaseUI.RiseupButton,
    TextInput: BaseUI.TextInput,
  },
  data() {
    return {
      nickname: '',
      buttonDisabled: false,
    };
  },
  computed: {
    ...mapState('accountabilityChallenge', ['ownerParticipantId']),
    ...mapState('session', ['customerId']),
    ...mapGetters('accountabilityChallenge', ['participantId']),
  },
  methods: {
    ...mapActions('modalRootStore', ['closeModal']),
    ...mapActions('accountabilityChallenge', ['joinChallenge', 'goToChallengeDashboard', 'initChallengeDashboard']),
    close() {
      this.closeModal();
    },
    setNickname(nickname) {
      this.nickname = nickname;
    },
    async joinChallengeClicked() {
      this.buttonDisabled = true;
      await this.joinChallenge({ nickname: this.nickname, isCustomer: this.customerId });
      Segment.trackUserInteraction('EatingOutChallengeJoinedChallenge', {
        challengeId: this.ownerParticipantId,
        participantId: this.participantId,
        nickname: this.nickname,
        shareName: EATING_OUT_CHALLENGE_PROTOTYPE_V1,
      });
      await this.initChallengeDashboard(this.customerId);
      this.close();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~base-ui/src/scss/riseup-colors';
.join-challenge-popup {
  .colored-top {
    .title {
      font-size: 22px;
      font-weight: bold;
      color: $riseup_white;
      text-align: right;
    }
  }
  .description {
    margin-bottom: 24px;
    text-align: right;
    font-size: 18px;
    font-family: SimplerPro;
  }
  .nickname-input {
    height: 60px;
  }
}
</style>
